@use '@grouper/modules/core/assets/scss/colors.scss' as colors;

:export {
  @each $color, $value in colors.$colors {
    #{unquote($color)}: $value;
  }
}
